import { useContext, useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { UserContext } from "../../utils/User_check";

function HeaderSection(){
  const {user,role, permissions} = useContext(UserContext);
  const navigate = useNavigate();

  const [isToggled, setIsToggled] = useState(false);

  const handleToggle = () => {
    setIsToggled(prevState => !prevState); // Bascule l'état
  };

  useEffect(()=>{

  },[user]);

  
    return (
        <>
        <div class="horizontal-menu">
          <nav class="navbar top-navbar col-lg-12 col-12 p-0">
            <div class="container">
              <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
                <Link class="navbar-brand brand-logo" to="/">
                  <img src="../assets/logo.png" style={{height:50,width:50}} alt="logo" className="text-center" />
                  <span class="font-12 d-block font-weight-light">DISTRIFORCE RP</span>
                </Link>
                <Link class="navbar-brand brand-logo-mini" to="/"><img src="../assets/images/logo-mini.svg" alt="logo" /></Link>
              </div>
              <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end">
                {/* <ul class="navbar-nav mr-lg-2">
                  <li class="nav-item nav-search d-none d-lg-block">
                    <div class="input-group">
                      <div class="input-group-prepend hover-cursor" id="navbar-search-icon">
                        <span class="input-group-text" id="search">
                          <i class="mdi mdi-magnify"></i>
                        </span>
                      </div>
                      <input type="text" class="form-control" id="navbar-search-input" placeholder="Search" aria-label="search" aria-describedby="search" />
                    </div>
                  </li>
                </ul> */}
                <ul class="navbar-nav navbar-nav-right">
                  <li class="nav-item nav-profile dropdown">
                    <a class="nav-link" id="profileDropdown" href="#" data-toggle="dropdown" aria-expanded="false">
                      <div class="nav-profile-img">
                        <img src="../assets/images/faces-clipart/pic-4.png" alt="image" />
                      </div>
                      <div class="nav-profile-text">
                        <p class="text-black font-weight-semibold m-0"> {user?.name} </p>
                        <span class="font-13 online-color">En ligne <i class="mdi mdi-chevron-down"></i></span>
                      </div>
                    </a>
                    <div class="dropdown-menu navbar-dropdown" aria-labelledby="profileDropdown">
                      {/* <a class="dropdown-item" href="#">
                        <i class="mdi mdi-cached mr-2 text-success"></i> Activity Log </a> */}
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" href="#" onClick={()=>{localStorage.removeItem('_token_');navigate('/auth')}}>
                        <i class="mdi mdi-logout mr-2 text-primary"></i> Se deconnecter </a>
                    </div>
                  </li>
                </ul>
                <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" onClick={handleToggle}>
                  <span class="mdi mdi-menu " ></span>
                </button>
              </div>
            </div>
          </nav>
          <nav class={`bottom-navbar ${isToggled ? "header-toggled" : ""}`}>
            <div class="container">
              <ul class="nav page-navigation">
               <li class="nav-item">
                  <NavLink className={({isActive}) => `nav-link${isActive ? " active" : ""}`} to="/" end>
                    <i class="mdi mdi-compass-outline menu-icon"></i>
                    <span class="menu-title">EVD</span>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink className={({isActive}) => `nav-link${isActive ? " active" : ""}`} to="/momo">
                    <i class="mdi mdi-buffer menu-icon"></i>
                    <span class="menu-title">CICO</span>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink className={({isActive}) => `nav-link${isActive ? " active" : ""}`} to="/commerciaux">
                    <i class="mdi mdi-contacts menu-icon"></i>
                    <span class="menu-title">Commerciaux</span>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink className={({isActive}) => `nav-link${isActive ? " active" : ""}`} to="/list-transaction-adv">
                    <i class="mdi mdi-account-card-details menu-icon"></i>
                    <span class="menu-title">ADV</span>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink className={({isActive}) => `nav-link${isActive ? " active" : ""}`} to="/approvisionnements">
                    <i class="mdi mdi-chart-bar menu-icon"></i>
                    <span class="menu-title">Approvisionnements</span>
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink className={({isActive}) => `nav-link${isActive ? " active" : ""}`} to="/home-stats">
                    <i class="mdi mdi-clipboard-text menu-icon"></i>
                    <span class="menu-title">Statistiques</span>
                  </NavLink>
                </li>
                 <li class="nav-item">
                  <a href="#" class="nav-link">
                    <i class="mdi mdi-monitor-dashboard menu-icon"></i>
                    <span class="menu-title">Gesites</span>
                    <i class="menu-arrow"></i>
                  </a>
                  <div class="submenu">
                    <ul class="submenu-item">
                      <li class="nav-item">
                        <Link class="nav-link" to="/fonds-roulements-sites">FONDS DE ROULEMENT</Link>
                      </li>
                      <li class="nav-item">
                        <Link class="nav-link" to="/transactions-solde-gesites">TRANSACTIONS</Link>
                      </li>
                      <li class="nav-item">
                        <Link class="nav-link" to="/degradation-fond-roulements">SUIVI DES DEGRADATIONS</Link>
                      </li>
                      <li class="nav-item">
                        <Link class="nav-link" to="/inventaire-caisses">CAISSE</Link>
                      </li>     
                      <li class="nav-item">
                        <Link class="nav-link" to="/ecarts-list">ECART</Link>
                      </li>                  
                      {/* <li class="nav-item">
                        <a class="nav-link" href="/performances-pages">PERFORMANCES</a>
                      </li> */}
                      {/* <li class="nav-item">
                        <a class="nav-link" href="/parametres/others">Autres</a>
                      </li> */}
                    </ul>
                  </div>
                </li> 
                <li class="nav-item">
                  <NavLink className={({isActive}) => `nav-link${isActive ? " active" : ""}`} to="/parametres/others">
                    <i class="mdi mdi-table-large menu-icon"></i>
                    <span class="menu-title">Paramètres</span>
                  </NavLink>
                </li>
                {/* <li class="nav-item">
                  <a href="https://www.bootstrapdash.com/demo/plus-free/documentation/documentation.html" class="nav-link" target="_blank">
                    <i class="mdi mdi-file-document-box menu-icon"></i>
                    <span class="menu-title">Documents</span></a>
                </li> */}
                {/* <li class="nav-item">
                  <div class="nav-link d-flex">
                    <button class="btn btn-sm bg-danger text-white"> Trailing </button>
                    <div class="nav-item dropdown">
                      <a class="nav-link count-indicator dropdown-toggle text-white font-weight-semibold" id="notificationDropdown" href="#" data-toggle="dropdown"> English </a>
                      <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="notificationDropdown">
                        <a class="dropdown-item" href="#">
                          <i class="flag-icon flag-icon-bl mr-3"></i> French </a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#">
                          <i class="flag-icon flag-icon-cn mr-3"></i> Chinese </a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#">
                          <i class="flag-icon flag-icon-de mr-3"></i> German </a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#">
                          <i class="flag-icon flag-icon-ru mr-3"></i>Russian </a>
                      </div>
                    </div>
                    <a class="text-white" href="index.html"><i class="mdi mdi-home-circle"></i></a>
                  </div>
                </li> */}
              </ul>
            </div>
          </nav>
      </div>
        </>
    );
}

export default HeaderSection;